import api, { objectToFormData } from './api';
import type { Stylist } from '@app-types/models/stylist';

type FormDataValue = string | number | boolean | File | Blob | null | undefined | FormDataValue[] | { [key: string]: FormDataValue };

interface CreateStylistParams {
  email: string;
}

interface CreateStylistResponse {
  staff: Stylist;
  token?: string;
  message?: string;
}

export const getStylists = async (): Promise<Stylist[]> => {
  const response = await api.get<unknown>('/business/stylists');
  // Accept both envelope ({success, data: [...]}) and raw arrays.
  const body = response.data as unknown as Stylist[] | { data?: Stylist[] };
  if (Array.isArray(body)) return body;
  if (Array.isArray((body as { data?: Stylist[] }).data)) return (body as { data: Stylist[] }).data;
  return [];
};

export const getStylistDetails = async (staffId: string): Promise<Stylist> => {
  const response = await api.get<Stylist>(`/stylist/profile`, { params: { staffId } });
  return response.data;
};

export const updateStylistDetails = async (stylistData: Record<string, FormDataValue>): Promise<Stylist> => {
  const formData = objectToFormData(stylistData);

  const response = await api.put<Stylist>(`/stylist/profile`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const createStylist = async ({email}: CreateStylistParams): Promise<CreateStylistResponse> => {
  const response = await api.post<CreateStylistResponse>('/business/create-stylist', { email });
  const user = JSON.parse(localStorage.getItem('user') || '{}') as { email?: string };
  if (user && user.email === email && response.data.token) {
    localStorage.setItem('token', response.data.token);
  }
  return response.data;
};

export const archiveStylist = async (stylistId: string): Promise<Stylist> => {
  const response = await api.put<Stylist>(`/business/stylist/${stylistId}/archive`);
  return response.data;
};
